const IconShop = (): JSX.Element => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.55009 17.3584C8.0388 17.3584 7.59909 17.5368 7.24119 17.8937C6.88328 18.2506 6.69922 18.6868 6.69922 19.1924C6.69922 19.6979 6.88328 20.1341 7.24119 20.4811C7.59909 20.838 8.0388 21.0164 8.55009 21.0164C9.06138 21.0164 9.50109 20.838 9.859 20.4811C10.2169 20.1242 10.401 19.688 10.401 19.1924C10.401 18.6967 10.2169 18.2506 9.859 17.8937C9.50109 17.5368 9.06138 17.3584 8.55009 17.3584Z"
          fill="currentColor"
        />
        <path
          d="M17.4056 17.3584C16.8943 17.3584 16.4546 17.5368 16.0967 17.8937C15.7388 18.2506 15.5547 18.6868 15.5547 19.1924C15.5547 19.6979 15.7388 20.1341 16.0967 20.4811C16.4546 20.838 16.8943 21.0164 17.4056 21.0164C17.9169 21.0164 18.3566 20.838 18.7145 20.4811C19.0724 20.1242 19.2564 19.688 19.2564 19.1924C19.2564 18.6967 19.0724 18.2506 18.7145 17.8937C18.3566 17.5368 17.9169 17.3584 17.4056 17.3584Z"
          fill="currentColor"
        />
        <path
          d="M20.7693 5.29382C20.5443 4.90721 20.2068 4.70894 19.7671 4.70894H6.89282L6.07475 2.97412H3.06836V4.78825H4.88856L8.13014 11.6086L6.77011 14.0968C6.44288 14.6916 6.44288 15.2368 6.77011 15.7325C7.09733 16.2182 7.61885 16.4562 8.32443 16.4562H19.2558V14.642H8.5494L9.52085 12.8576H16.0756C16.4335 12.8576 16.771 12.7585 17.0675 12.5602C17.3641 12.3719 17.5993 12.1141 17.7833 11.8068L20.7693 6.4735C20.984 6.0968 20.984 5.69035 20.7693 5.31365V5.29382ZM18.5503 6.51315L16.0552 11.0237H9.99124L7.80291 6.51315H18.5503Z"
          fill="currentColor"
        />
      </svg>
    </>
  );
};

export default IconShop;
